import apiBug from './apiBug/index'
import apiLogin from './apiLogin/index'
import apiSferest from './apiSferest/index'
import apiUsers from './apiUsersManagement/index'
import tokenInterceptor from '@/api/interceptors/request.token.interceptor'
import errorInterceptor from '@/api/interceptors/response.errors.interceptor'
import loginInterceptor from '@/api/interceptors/responseLogin.token.interceptor'

// API BUG
apiBug.interceptors.request.use(tokenInterceptor.onRequestAuthorization, tokenInterceptor.onError)
apiBug.interceptors.response.use(errorInterceptor.onResponse, errorInterceptor.onError)

// API LOGIN
apiLogin.interceptors.response.use(loginInterceptor.onResponse, loginInterceptor.onError)

// API SFE REST
apiSferest.interceptors.request.use(tokenInterceptor.onRequestToken, tokenInterceptor.onError)
apiSferest.interceptors.response.use(errorInterceptor.onResponse, errorInterceptor.onError)

// API USERS
apiUsers.interceptors.request.use(tokenInterceptor.onRequestAuthorization, tokenInterceptor.onError)
apiUsers.interceptors.response.use(errorInterceptor.onResponse, errorInterceptor.onError)

export default {
  apiBug,
  apiLogin,
  apiSferest,
  apiUsers
}
